import { Component, EventEmitter, Input, Output } from '@angular/core';
import moment from 'moment';
import { Timeframe } from './time-frame.interface';

@Component({
  selector: 'app-time-interval-selector',
  templateUrl: './time-interval-selector.component.html',
  styleUrls: ['./time-interval-selector.component.scss'],
  standalone: false
})
export class TimeIntervalSelectorComponent {  
  @Input() startTime = moment().startOf('day');
  @Input() endTime = moment().endOf('day');
  @Output() timeChange = new EventEmitter<Timeframe>();
  
  invalid = false;
  readonly timeFormat = 'HH:mm';

  selectStartTime(event: string): void {
    this.startTime = moment(event, this.timeFormat);
    this.handleTimeChange();
  }

  selectEndTime(event: string): void {
    this.endTime = moment(event, this.timeFormat);
    this.handleTimeChange();
  }

  private handleTimeChange(): void {
    const startTime = moment(this.startTime, this.timeFormat, true);
    const endTime = moment(this.endTime, this.timeFormat, true);

    this.invalid = !startTime.isValid() || !endTime.isValid() || startTime.isAfter(endTime);

    if (!this.invalid) {
      this.timeChange.emit({ startTime, endTime });
    }
  }
}
